import { createSelector } from '@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { Contact } from './models';
import { baseApi } from '@centerpiece/components';

export const contact = baseApi
  .enhanceEndpoints({ addTagTypes: ['Contacts', 'Contact'] })
  .injectEndpoints({
    endpoints: builder => ({
      getContacts: builder.query<Contact[], { params?: object }>({
        query: ({ params }: { params?: object }) => ({
          url: 'contact',
          method: 'GET',
          params: params ? { nested: 'all', ...params } : { nested: 'all' },
        }),
        // transformResponse: (data: Contact[], meta, arg) => {
        //   const contacts: Array<Contact> = data.map((c: Contact) => {
        //     //flatten project quote infi
        //     return {
        //       ...c,
        //       organization:
        //         c.form?.organization ||
        //         c.form?.custom_fields?.find((cf: any) => cf.organization !== '')
        //           ?.organization,
        //     };
        //   });
        //   return contacts;
        // },
        providesTags: (result, error, arg) =>
          result
            ? [
                ...result.map(({ id }) => ({ type: 'Contact' as const, id })),
                'Contacts',
              ]
            : ['Contacts'],
      }),
      getContact: builder.query<Contact, { id: number; params?: object }>({
        query: ({ id, params }: { id: number; params?: object }) => ({
          url: `contact/${id}`,
          method: 'GET',
          params: params,
        }),
        providesTags: (result, error, arg) => [{ type: 'Contact', id: arg.id }],
        // configuration for an individual endpoint, overriding the api setting
        keepUnusedDataFor: 90,
      }),
      createContact: builder.mutation({
        query: request => ({
          url: 'contact',
          method: 'POST',
          body: request,
        }),
        invalidatesTags: ['Contacts'],
      }),
      patchContact: builder.mutation<Contact, Contact>({
        query: request => ({
          url: `contact/${request.id}`,
          method: 'PATCH',
          body: request,
        }),
        invalidatesTags: (result, error, arg) => [
          { type: 'Contact', id: arg.id },
        ],
        // async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
        //   const patchResult = dispatch(
        //     contact.util.updateQueryData('getContact', { id }, draft => {
        //       Object.assign(draft, patch);
        //     })
        //   );
        //   try {
        //     await queryFulfilled;
        //   } catch {
        //     patchResult.undo();

        //     /**
        //      * Alternatively, on failure you can invalidate the corresponding cache tags
        //      * to trigger a re-fetch:
        //      * dispatch(contact.util.invalidateTags(['Contacts']))
        //      */
        //     dispatch(contact.util.invalidateTags(['Contacts']));
        //   }
        // },
      }),
      updateContact: builder.mutation<Contact, Contact>({
        query: request => ({
          url: `contact/${request.id}`,
          method: 'PUT',
          body: request,
        }),
        invalidatesTags: (result, error, arg) => [
          { type: 'Contact', id: arg.id },
        ],
        async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
          const patchResult = dispatch(
            contact.util.updateQueryData('getContact', { id }, draft => {
              Object.assign(draft, patch);
            })
          );
          try {
            await queryFulfilled;
          } catch {
            patchResult.undo();

            /**
             * Alternatively, on failure you can invalidate the corresponding cache tags
             * to trigger a re-fetch:
             * dispatch(contact.util.invalidateTags(['Contacts']))
             */
            dispatch(contact.util.invalidateTags(['Contacts']));
          }
        },
      }),
      deleteContact: builder.mutation<Contact, number>({
        query: id => ({
          url: `contact/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: (result, error, arg) =>
          result
            ? [{ type: 'Contact' as const, arg }, 'Contacts']
            : ['Contacts'],
      }),
    }),
  });

// Auto-generated hooks
export const {
  useGetContactsQuery,
  useGetContactQuery,
  useCreateContactMutation,
  usePatchContactMutation,
  useUpdateContactMutation,
  useDeleteContactMutation,
  usePrefetch: useContactsPrefetch,
} = contact;
const selectContactsRoot = contact.endpoints.getContacts.select({});
export const selectContacts = createSelector(
  selectContactsRoot,
  contact => contact.data || []
);
